import { createAction } from "@reduxjs/toolkit";

export const openDeleteDialog = createAction('app/openDeleteDialog');
export const closeDeleteDialog = createAction('app/closeDeleteDialog');
export const openFillTemplateDialog = createAction('app/openFillTemplateDialog');
export const closeFillTemplateDialog = createAction('app/closeFillTemplateDialog');
export const openFilePreviewDialog = createAction('app/openFilePreviewDialog');
export const closeFilePreviewDialog = createAction('app/closeFilePreviewDialog');
export const setManagerDrawer = createAction('app/setManagerDrawer');
export const setLocationDrawer = createAction('app/setLocationDrawer');
export const setClinicianDrawer = createAction('app/setClinicianDrawer');
export const setSixthFlowPromptsDrawer = createAction('app/setSixthFlowPromptsDrawer');
export const setSuperbillGoalDrawer = createAction('app/setSuperbillGoalDrawer');
export const setEsignFlowDrawer = createAction('app/setEsignFlowDrawer');
export const setAbortController = createAction('app/setAbortController');